import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import TitlePages from "../../layout/TitlePages";
import Breadcrumbs from "../../layout/Breadcrumbs";
import "./Transparencia.css";

const PreguntasFrecuentes = () => {
  useEffect(() => {
    document.title = `Preguntas Frecuentes`;
  }, []);
  return (
    <>
      <Breadcrumbs path={[{ label: "Preguntas Frecuentes" }]} />
      <TitlePages title="Preguntas Frecuentes" subTitle="" />

      <div className="mt-3 margin-bottom-2">
        <ol type="I" start="1">
          <li className="Preguntas__list">
            ¿Dónde puedo consultar los Resultados Electorales de las Elecciones
            celebradas en el Estado de Tlaxcala?
          </li>
          <strong>Respuesta:</strong>
          <p>
            Te informamos que el Instituto Tlaxcalteca de Elecciones, es
            responsable del ejercicio de la función estatal de preparación,
            organización, desarrollo, vigilancia y validez de los procesos de
            elección para renovar los poderes Legislativo y Ejecutivo del
            Estado, los ayuntamientos y las presidencias de comunidad (artículo
            20 de la Ley de Instituciones y Procedimientos Electorales Para el
            Estado de Tlaxcala).
          </p>
          <p>
            Consulta los resultados electorales de las elecciones de
            Gubernaturas, Diputaciones, Ayuntamientos y Presidencias de
            Comunidad en el siguiente enlace:
          </p>
          <p className="text-center">
            <Link
              className="btn btn-ite"
              to="/ProcesosElectorales"
              target="_blank"
              rel="noreferrer"
            >
              Procesos Electorales
            </Link>
          </p>



          <li className="Preguntas__list">
            ¿Dónde puedo consultar a las candidaturas del Proceso Electoral Local Extraordinario del Poder Judicial?
          </li>
          <strong>Respuesta:</strong>
          <p>
            El Instituto Tlaxcalteca de Elecciones ha creado un micrositio para consulta
            de la ciudadania respecto a la Elección Judicial Local 2025, te invitamos a conocer 
            más en el siguiente enlace: 
          </p>
          <p className="text-center">
            <Link
              className="btn btn-ite"
              to="https://pelepj-2025.itetlax.org.mx/?route=lista-candidaturas"
              target="_blank"
              rel="noreferrer"
            >
              Lista de Candidaturas
            </Link>
          </p>


          <li className="Preguntas__list">
          ¿Cuánto presupuesto se destinó al Proceso Electoral Local Extraordinario del Poder Judicial?
          </li>
          <strong>Respuesta:</strong>
          <p>
          El Instituto Tlaxcalteca de Elecciones recibió $75,000,000.00 (Setenta y cinco millones de pesos 00/100 M.N) para el desarrollo del Proceso Electoral Local Extraordinario del Poder Judicial, lo anterior de conformidad con el Decreto N°138 del Periódico Oficial publicado el dieciocho de marzo del año dos mil veinticinco. 
          </p>
          <div className="d-flex align-items-center gap-2 mt-2">
            <a href="assets/pdf/transparencia/DECRETO_138.pdf"
                target="_blank"
                className="btn btn-danger btn-sm rounded-circle">
                <i className="fa-solid fa-file-pdf"></i>
            </a>
            <span>
              Presupuesto del Proceso Electoral Local Extraordinario del Poder Judicial
            </span>
          </div>

          <li className="Preguntas__list">
            ¿Cuál es el Programa Anual de Auditorías Internas del Órgano Interno de Control del Instituto Tlaxcalteca de Elecciones?
          </li>
          <strong>Respuesta:</strong>
          <p>
            El Órgano Interno de Control cuenta con un Cronograma de Actividades de Auditoria para el ejercicio fiscal 2025, el cual esta disponible en el siguiente hipervinculo.
          </p>
          <p className="text-center">
            <Link
              className="btn btn-ite"
              to="https://drive.google.com/file/d/1cc--BxPO4iHXQm3kwFZoAPxXLCvp5f_W/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
            >
              Cronograma de Actividades
            </Link>
          </p>

          <li className="Preguntas__list">
            ¿Cómo puedo saber quiénes se registraron como candidatos/as a un
            cargo de elección en el Estado de Tlaxcala?
          </li>
          <strong>Respuesta:</strong>
          <p>
            El artículo 8 fracción II de la Ley de Instituciones y
            Procedimientos Electorales para el Estado de Tlaxcala, señala que es
            un derecho poder ser votado para todos los cargos de elección
            popular y para ser nombrado para desempeñar cualquier otro empleo o
            comisión, teniendo las cualidades que establezca la Constitución
            Local las demás leyes aplicables.
          </p>
          <p>
            El derecho de solicitar el registro de candidatos ante la autoridad
            electoral corresponde a los partidos políticos, así como a los
            ciudadanos que soliciten su registro de manera independiente a
            aquéllos y cumplan con los requisitos, condiciones y términos que
            determinen las leyes aplicables.
          </p>
          <p>
            Puedes consultar los acuerdos del Consejo General del Instituto
            Tlaxcalteca de Elecciones mediante los que se aprobaron registros de
            candidaturas a diferentes cargos de elección, dando clic en el
            siguiente enlace:
          </p  >
          <p className="text-center">
            <Link
              className="btn btn-ite"
              to="/Acuerdos2025"
              target="_blank"
              rel="noreferrer"
            >
              Acuerdos 2025
            </Link>
          </p>
          <li className="Preguntas__list">
            ¿Dónde puedo consultar la Lista Nominal y el Padrón Electoral?
          </li>
          <strong>Respuesta:</strong>
          <p>
            De conformidad con lo dispuesto por los artículos 41, base V,
            apartado B, inciso a, numeral 3, de la Constitución Política de los
            Estados Unidos Mexicanos, y 32, numeral 1, inciso a), fracción III
            de la Ley General de Instituciones y Procedimientos Electorales, es
            atribución del Instituto Nacional Electoral para los procesos
            electorales federales y locales formar y administrar el padrón
            electoral y la lista nominal de electores. Por lo que puedes
            solicitar esta información a dicho Órgano Electoral.
          </p>
          <p>
            Puedes presentar tu solicitud dirigida al Instituto Nacional
            Electoral accediendo al siguiente enlace:
          </p>
          <p className="text-center">
            <a
              className="btn btn-ite"
              href="https://listanominal.ine.mx/scpln/"
              target="_blank"
              rel="noreferrer"
            >
              Lista nominal y padrón electoral
            </a>
          </p>
          <li className="Preguntas__list">
            ¿Cuál es el presupuesto otorgado al Instituto Tlaxcalteca de
            Elecciones?
          </li>
          <strong>Respuesta:</strong>
          <p>
            Te informamos que al Instituto Tlaxcalteca de Elecciones le es
            aprobado un presupuesto cada ejercicio fiscal, por parte del
            Congreso del Estado, mediante el cual cumple con sus funciones, gran
            parte de este recuso se otorga a los partidos políticos.
          </p>
          <p>
            Te invitamos a que conozcas el presupuesto otorgado a nuestro
            Instituto:
          </p>

          <div className="table-responsive">
            <table className="table text-center table-striped table-hover w-50 mx-auto">
              <thead>
                <tr>
                  <th scope="col">Ejercicio</th>
                  <th scope="col">Presupuesto otorgado</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2021</td>
                  <td>$185,782,415.00</td>
                </tr>
                <tr>
                  <td>2022</td>
                  <td>$106,128,665.79</td>
                </tr>
                <tr>
                  <td>2023</td>
                  <td>$14,351,216.00</td>
                </tr>
                <tr>
                  <td>2024</td>
                  <td>$14,351,216.00</td>
                </tr>
                <tr>
                  <td>2025</td>
                  <td>$128,806,150.00</td>
                </tr>
                <tr>
                  <td>2025 AMPLIACIÓN PARA EL PROCESO ELECTORAL LOCAL EXTRAORDINARIO DEL PODER JUDICIAL</td>
                  <td>$75,000,000.00</td>
                </tr>
                <tr>
                  <td>2026</td>
                  <td>$134,990,553.00</td>
                </tr>
              </tbody>
            </table>
          </div>
          <li className="Preguntas__list">
            ¿Cuál es el monto de las Prerrogativas otorgadas a los Partidos
            Políticos?
          </li>
          <strong>Respuesta:</strong>
          <p>
            Con fundamento en el artículo 76, fracción IV, de la Ley de
            Instituciones y Procedimientos Electorales Para el Estado de
            Tlaxcala, el Instituto Tlaxcalteca de Elecciones a través de la
            Dirección de Prerrogativas, Administración y Fiscalización es el
            encargado de otorgar las prerrogativas a los Partidos Políticos.
            Estas prerrogativas se desprenden del recurso otorgado al Instituto
            Tlaxcalteca de Elecciones.
          </p>
          <p>
            Consulta las prerrogativas que el Instituto Tlaxcalteca de
            Elecciones ha otorgado a los partidos políticos.
          </p>
          <div className="table-responsive align-middle">
            <table className="table table-striped table-hover text-center">
              <thead>
                <tr>
                  <th rowSpan="2">PARTIDO POLÍTICO</th>
                  <th colSpan="10">EJERCICIO</th>
                </tr>
                <tr>
                  <th>2021</th>
                  <th>2022</th>
                  <th>2023</th>
                  <th>2024</th>
                  <th>2025</th>
                  <th>2026</th>
                </tr>
              </thead>
              <tbody className="table-group-divider">
                <tr>
                  <th scope="row">Partido Acción Nacional</th>
                  <td>$9,224,124.08</td>
                  <td>$6,182,254.86</td>
                  <td>$57,287,747.00</td>
                  <td>$10,520,093.80</td>
                  <td>$6,815,044.00</td>
                  <td>$7,244,381.00</td>
                </tr>
                <tr>
                  <th scope="row">Partido Revolucionario Institucional</th>
                  <td>$4,832,677.55</td>
                  <td>$7,924,120.58</td>
                  <td>$9,341,087.00</td>
                  <td>$13,483,122.10</td>
                  <td>$6,844,200.00</td>
                  <td>$7,275,373.00</td>
                </tr>
                <tr>
                  <th scope="row">Partido de la Revolución Democrática</th>
                  <td>$5,454,360.93</td>
                  <td>$4,150,946.11</td>
                  <td>$4,893,206.00</td>
                  <td>$7,064,703.81</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Partido de la Revolución Democrática Tlaxcala</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>$4,839,978.00</td>
                  <td>$5,144,889.00</td>
                </tr>
                <tr>
                  <th scope="row">Partido del Trabajo</th>
                  <td>$7,317,919.98</td>
                  <td>$5,288,732.35</td>
                  <td>$6,234,448.00</td>
                  <td>$9,000,153.14</td>
                  <td>$9,876,872.00</td>
                  <td>$10,499,099.00</td>
                </tr>
                <tr>
                  <th scope="row">Partido Verde Ecologista de México</th>
                  <td>$4,826,613.79</td>
                  <td>$3,180,506.22</td>
                  <td>$3,749,234.00</td>
                  <td>$5,413,921.63</td>
                  <td>$5,684,859.00</td>
                  <td>$6,042,997.00</td>
                </tr>
                <tr>
                  <th scope="row">Movimiento Ciudadano</th>
                  <td>$5,665,001.65</td>
                  <td>$1,096,520.59</td>
                  <td>$1,292,597.00</td>
                  <td>$1,861,353.22</td>
                  <td>$8,153,789.00</td>
                  <td>$8,667,464.00</td>
                </tr>
                <tr>
                  <th scope="row">Morena</th>
                  <td>$25,694,956.22</td>
                  <td>$13,861,256.38</td>
                  <td>$16,339,884.00</td>
                  <td>$,23,582,581.10</td>
                  <td>$14,127,116.00</td>
                  <td>$15,017,102.00</td>
                </tr>
                <tr>
                  <th scope="row">Nueva Alianza</th>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Nueva Alianza Tlaxcala</th>
                  <td>$4,963,793.69</td>
                  <td>$3,574,472.74</td>
                  <td>$4,213,626.00</td>
                  <td>$6,084,050.61</td>
                  <td>$4,242,762.00</td>
                  <td>$4,510,049.00</td>
                </tr>
                <tr>
                  <th scope="row">Encuentro Social</th>
                  <td>$1,646,037.19</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Encuentro Social Tlaxcala</th>
                  <td>$4,446,188.11</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Partido Alianza Ciudadana</th>
                  <td>$1,646,037.19</td>
                  <td>$4,079,095.56</td>
                  <td>$4,808,506.00</td>
                  <td>$6,942,481.29</td>
                  <td>$6,029,091.00</td>
                  <td>$6,408,913.00</td>
                </tr>
                <tr>
                  <th scope="row">Partido Socialista</th>
                  <td>$1,646,037.19</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Impacto Social "Sí"</th>
                  <td>$1,646,037.19</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">Fuerza por México Tlaxcala</th>
                  <td></td>
                  <td>$3,817,027.52</td>
                  <td>$4,499,577.00</td>
                  <td>$6,496,686.30</td>
                  <td>$4,817,919.00</td>
                  <td>$5,121,440.00</td>
                </tr>
                <tr>
                  <th scope="row">Redes Sociales Progresistas Tlaxcala</th>
                  <td></td>
                  <td>$1,096,520.59</td>
                  <td>$1,292,597.00</td>
                  <td>$1,861,353.22</td>
                  <td>$3,979,517.00</td>
                  <td>$4,230,220.00</td>
                </tr>
              </tbody>
            </table>
          </div>
          <li className="Preguntas__list">
            ¿Dónde puedo consultar el Registro de Representantes ante mesas
            directivas de casilla?
          </li>
          <strong>Respuesta:</strong>
          <p>
            Te informamos que con base en los artículos 262 de la Ley General de
            Instituciones y Procedimientos Electorales, 254 del Reglamento de
            Elecciones del Instituto Nacional Electoral, el registro de
            representantes generales y ante mesas directivas de casilla, de
            partidos políticos y candidaturas independientes, en cualquier
            proceso electoral federal o local, sean estos ordinarios o
            extraordinarios, está a cargo del Instituto Nacional Electoral a
            través de sus Consejos Locales y Distritales.
          </p>
          <p>
            Puedes presentar tu solicitud dirigida al Instituto Nacional
            Electoral accediendo al siguiente enlace:
          </p>
          <p className="text-center">
            <a
              className="btn btn-ite"
              href="https://portalanterior.ine.mx/archivos3/portal/historico/contenido/Acreditacion_y_Presenciade_Representantes_de_Partidos_Politicos_ante_casillas/"
              target="_blank"
              rel="noreferrer"
            >
              Registro de Representantes ante mesas directivas de casilla
            </a>
          </p>
          <li className="Preguntas__list">
            ¿Qué mecanismos de Participación Ciudadana se han ejercido en el
            Estado de Tlaxcala?
          </li>
          <strong>Respuesta:</strong>
          <p>
            La Ley de Consulta Ciudadana para el Estado de Tlaxcala fue
            publicada en el Periódico Oficial del Gobierno del Estado de
            Tlaxcala el 26 de julio de 2006, y entró en vigor el 01 de enero de
            2007. Esta Ley regula los procesos de Iniciativa Popular, Consulta
            Popular, Plebiscito, Referéndum y Voz Ciudadana en el Cabildo.
          </p>
          <p>
            Desde la entrada en vigor y hasta la fecha{" "}
            <strong>
              no se ha ejercido alguno de los mecanismos de participación
              ciudadana que contempla la Ley.
            </strong>
          </p>
          <p>
            Te invitamos a que conozcas más a fondo los mecanismos de
            participación ciudadana que contempla nuestra ley, accediendo al
            siguiente enlace:
          </p>
          <p className="text-center">
            <a
              className="btn btn-ite"
              href="https://participacion-ciudadana.itetlax.org.mx/"
              target="_blank"
              rel="noreferrer"
            >
              Microstio Participación Ciudadana
            </a>
          </p>
          <li className="Preguntas__list">
            ¿Cuáles son las acciones afirmativas que ha emitido el Instituto
            Tlaxcalteca de Elecciones?
          </li>
          <strong>Respuesta:</strong>
          <p>
            Las acciones afirmativas constituyen medidas compensatorias para las
            personas en situaciones de desventaja, a fin de revertir escenarios
            de desigualdad histórica y de facto en el ejercicio de sus derechos.
          </p>
          <p>
            Preocupado por cerrar estas brechas de desigualdad histórica y
            social, y garantizar la inclusión el Instituto Tlaxcalteca de
            Elecciones ha emitido diversas acciones afirmativas para asegurar la
            participación en las elecciones de grupos históricamente vulnerados.
          </p>
          <p>
            Consulta las acciones afirmativas de este Órgano Electoral en los
            siguientes enlaces:
          </p>
          <p className="text-center">
            <a
              className="btn btn-ite"
              href="https://itetlax.org.mx/assets/pdf/acuerdos/ITE/2020/47.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Acuerdo ITE-CG 47/2020
            </a>{" "}
            <a
              className="btn btn-ite"
              href="https://itetlax.org.mx/assets/pdf/acuerdos/ITE/2020/64.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Acuerdo ITE-CG 64/2020
            </a>{" "}
            <a
              className="btn btn-ite"
              href="https://itetlax.org.mx/assets/pdf/acuerdos/ITE/2021/34.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Acuerdo ITE-CG 34/2021
            </a>{" "}
            <a
              className="btn btn-ite"
              href="https://itetlax.org.mx/assets/pdf/acuerdos/ITE/2021/132.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Acuerdo ITE-CG 132/2021
            </a>{" "}
            <a
              className="btn btn-ite"
              href="https://itetlax.org.mx/assets/pdf/memElect/11.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Memoria Electoral del Proceso Electoral Local Ordinario 2020 -
              2021 y Proceso Electoral Extraordinario 2021
            </a>{" "}
            <a
              className="btn btn-ite"
              href="https://ite-consulta-pcd.itetlax.org.mx/"
              target="_blank"
              rel="noreferrer"
            >
              Acciones Afirmativas para el Proceso Electoral Local Ordinario
              2023 - 2024
            </a>{" "}
          </p>
          <li className="Preguntas__list">
            ¿Dónde puedo consultar la información relativa a las elecciones que
            se han llevado a cabo en Tlaxcala?
          </li>
          <strong>Respuesta:</strong>
          <p>
            Después de cada proceso electoral el Instituto Tlaxcalteca de
            Elecciones, realiza un concentrado de información e imágenes sobre
            las actividades realizadas en los procesos electorales ordinarios o
            extraordinarios que desarrolla. A este documento se le denomina
            Memoria Electoral.
          </p>
          <p>
            Te invitamos a consultar las memorias electorales que ha elaborado
            nuestro Instituto a lo largo de diversos procesos electorales
            accediendo al siguiente enlace:
          </p>
          <p className="text-center">
            <a
              className="btn btn-ite"
              href="https://itetlax.org.mx/MemoriasElectorales"
              target="_blank"
              rel="noreferrer"
            >
              Memorias Electorales
            </a>
          </p>
          <li className="Preguntas__list">
            ¿Dónde puedo consultar la información sobre las acciones que el
            Instituto Tlaxcalteca de Elecciones ha llevado a cabo en favor de
            las mujeres Tlaxcaltecas?
          </li>
          <strong>Respuesta</strong>
          <p>
            El Instituto Tlaxcalteca de Elecciones ha emitido diversas acciones
            en pro de la promoción, fomento y preservación de los derechos
            político-electorales de las mujeres, te invitamos a conocer mas en
            el siguiente enlace:
          </p>
          <p className="text-center">
            <a
              className="btn btn-ite"
              href="https://ite-genero.itetlax.org.mx/"
              target="_blank"
              rel="noreferrer"
            >
              ITE Género
            </a>
          </p>
        </ol>
      </div>
    </>
  );
};
export default PreguntasFrecuentes;
